'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const Mn = require('backbone.marionette');
const ContentTemplate = require('balus/ui/template/body/account/index.hbs');
const UserTemplate = require('balus/ui/template/body/account/user.hbs');
const User = require('common/domain/entity/user');
const Ajax = require('common/infra/ajax');
const i18n = require('i18next');
const Snackbar = require('common/util/snackbar');

const UserView = Mn.View.extend({
    tagName: 'li',
    className: 'list-item',
    template: UserTemplate,
    events: {
        'click': 'login'
    },

    templateContext: function() {
        const primary = this.model.getEmails().getPrimary();
        return {
            email: primary ? primary.getAddress() : ''
        }
    },

    onRender: function() {
        const loginUser = this.getOption('loginUser');
        if(loginUser && loginUser.id == this.model.id) {
            this.$el.addClass('is-highlighted');
        } else {
            this.$el.addClass('list-item-clickable');
        }
    },

    login: function() {
        Ajax.GET(`/api/accounts/login?id=${this.model.id}`).then(userJson => {
            const urlParams = new URLSearchParams(location.search);
            const dstUrl = urlParams.get('dst_url');
            if(dstUrl) {
                location.href = decodeURIComponent(dstUrl);
            } else {
                location.href = '/';
            }
        });
    }
});

const UserListView = Mn.CollectionView.extend({
    tagName: 'ul',
    className: 'list',
    childView: UserView,
    initialize: function() {
        this.collection.models = _.sortBy(this.collection.models, (user) => { return user.get('name') });
    },
    childViewOptions: function() {
        return {
            loginUser: this.getOption('loginUser')
        }
    }
});

module.exports = Mn.View.extend({
    template: ContentTemplate,
    regions: {
        accounts: '.accounts'
    },

    templateContext: function() {
        const appInfo = this.getOption('appInfo');
        const user = this.model;
        const notSignupAvailable = appInfo.isProduction() && user && user.id && !user.isSiteAdmin();
        const isSignupAvailable = !notSignupAvailable;
        return {
            isSignupAvailable: isSignupAvailable
        };
    },

    onRender: function() {
        Ajax.GET('/api/accounts').then(usersJson => {
            this.showChildView('accounts', new UserListView({
                loginUser: this.model,
                collection: new Backbone.Collection(usersJson, {
                    model: User
                })
            }));
        }, reason => {
            if(reason.type == 'NotLoginError') {
                Snackbar.error(i18n.t(`view_body_account:error.${reason.type}`));
            }
            if(reason.type == 'ObjectNotFoundError') {
                Snackbar.error(i18n.t(`view_body_account:error.${reason.type}`));
            }
        })
    },
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/account/index.js